import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../../common/SvgIcon';
import GettingStartedDeliveryOption from './GettingStartedDeliveryOption';
import GettingStartedDeliveryRoom from './GettingStartedDeliveryRoom';

const GettingStartedDelivery = (
  { value, rooms, prices, delivery, children, className, invalid, onChange },
  ref,
) => (
  <div ref={ref} className={cn('tab', className)}>
    <div className="tab_question">Question 5 of 7</div>
    <div className="tab_tag">
      <SvgIcon icon="icon-question-step-6" />
    </div>
    <div className="tab_title">
      <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
        In a hurry? Add our express upgrade to get
        <br />
        your design in 10 working days.
        {invalid && (
          <div className="form-error">
            please choose standard or
            <br />
            express delivery for all rooms
          </div>
        )}
      </div>
      <div className="tile-selection_bottom-description">
        (Our standard service is up to 3 weeks)
      </div>
    </div>

    <div className="getting-started_tags">
      {rooms.map(room => (
        <GettingStartedDeliveryRoom
          key={room.value}
          value={value}
          prices={prices}
          room={room}
          onChange={onChange}
        />
      ))}
    </div>

    <div className="getting-started_packages">
      {delivery.map(option => (
        <GettingStartedDeliveryOption key={option.name} option={option} />
      ))}
    </div>

    {children}

    <div className="tab_hint">
      Still have questions? You can&nbsp;
      <a href="/free-consultation/new">
        schedule a call
      </a>
      &nbsp;or&nbsp;
      <a href="mailto:hello@mybespokeroom.com" target="_blank" rel="noopener noreferrer">
        e-mail
      </a>
      &nbsp;us.
    </div>
  </div>
);

export default forwardRef(GettingStartedDelivery);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedDelivery/GettingStartedDelivery.js